import { render, staticRenderFns } from "./QueryText.vue?vue&type=template&id=5606ad1c&scoped=true"
import script from "./QueryText.vue?vue&type=script&lang=js"
export * from "./QueryText.vue?vue&type=script&lang=js"
import style0 from "./QueryText.vue?vue&type=style&index=0&id=5606ad1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606ad1c",
  null
  
)

export default component.exports